//--todo add more Diff Combination for Radio
export var StepperTypeTokens;
(function (StepperTypeTokens) {
    StepperTypeTokens["HORIZONTAL"] = "HORIZONTAL";
    StepperTypeTokens["VERTICAL"] = "VERTICAL";
    StepperTypeTokens["DISTRIBUTOR"] = "DISTRIBUTOR";
    StepperTypeTokens["PARTNER"] = "PARTNER";
})(StepperTypeTokens || (StepperTypeTokens = {}));
export var StepperStateToken;
(function (StepperStateToken) {
    StepperStateToken["NOT_STARTED"] = "NOT_STARTED";
    StepperStateToken["IN_PROGRESS"] = "IN_PROGRESS";
    StepperStateToken["COMPLETED"] = "COMPLETED";
    StepperStateToken["SKIPPED"] = "SKIPPED";
    StepperStateToken["FAILED"] = "FAILED";
    StepperStateToken["BLOCKED"] = "BLOCKED";
    StepperStateToken["PENDING_CALLBACK"] = "PENDING_CALLBACK";
    StepperStateToken["PENDING_MANUAL_VERIFICATION"] = "PENDING_MANUAL_VERIFICATION";
    StepperStateToken["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
})(StepperStateToken || (StepperStateToken = {}));
